import { useState } from 'react';

export const useCustomAlert = () => {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    message: ''
  });

  const showAlert = (message) => {
    setAlertState({
      isOpen: true,
      message: message
    });
  };

  const closeAlert = () => {
    setAlertState({
      isOpen: false,
      message: ''
    });
  };

  return {
    alertState,
    showAlert,
    closeAlert
  };
};
